import { APICore } from './apiCore'

const api = new APICore()

function getEstadisticas (params) {
  const baseUrl = '/estadisticas-infotools'
  return api.get(baseUrl, params)
}

function addEstadistica (params) {
  const baseUrl = '/estadisticas-infotools'
  return api.create(baseUrl, params)
}

export { getEstadisticas, addEstadistica }
